import React from 'react';
import IconCheckWhite from '../../../Icons/IconCheckWhite';
import ImageProvaider from './ImageProvaider';

const BloqueTexto = ({ isPromocion, isEroski, isDestacado, data }) => {
  return (
    <div
      className={`${
        !isPromocion &&
        (!isEroski && isDestacado
          ? 'bloque-vale__texto_destacado'
          : 'bloque-vale__texto')
      }`}
    >
      {!isPromocion && data.tipoLista !== 1 && (
        <div className="icon-activado">
          <div className="icon icon-medium">
            <IconCheckWhite classCss="" />
          </div>
        </div>
      )}

      {!isPromocion && <ImageProvaider data={data} isPromocion={isPromocion} />}
    </div>
  );
};

export default BloqueTexto;
